import { NewRelic, PageActions } from '../../../Types/globalTypes'
import { useMemo } from 'react'

type UseNewRelic = { newRelic: NewRelic['newrelic']; pageActions: PageActions }

/**
 * * This hook provides the new relic object and page actions
 * ! Note that newRelic might be undefined depending on the featBit settings
 */
const useNewRelic = (): UseNewRelic => {
  const newRelic = (window as unknown as NewRelic)?.newrelic
  const pageActions: PageActions = useMemo(
    () => ({
      componentClicked: ({ componentName, elementName, userId }) => {
        newRelic?.addPageAction('componentClicked', { componentName, elementName, userId })
      },
      redirect: ({ redirectedFrom, redirectedTo }) => {
        newRelic?.addPageAction('redirect', { redirectedFrom, redirectedTo })
      },
      logEvent: ({ logValue }) => {
        newRelic?.addPageAction('logEvent', { logValue })
      },
      track: ({ actionName, attributes }) => {
        newRelic?.addPageAction('track', { actionName, attributes })
      },
      apiRequest: ({ normalizedUrl, httpStatus }) => {
        newRelic?.addPageAction('apiRequest', { normalizedUrl, httpStatus })
      },
    }),
    [newRelic]
  )

  return { newRelic, pageActions }
}

export default useNewRelic
